var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoFactor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.66 44.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #32a1b3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.55,35.33c.28.28.65.43,1.04.43s.76-.15,1.04-.43l8.26-8.26c.28-.28.43-.65.43-1.04,0-.39-.15-.76-.43-1.04-.57-.57-1.5-.57-2.08,0l-7.22,7.22-2.93-2.93c-.28-.28-.65-.43-1.04-.43s-.76.15-1.04.43c-.28.28-.43.65-.43,1.04,0,.39.15.76.43,1.04l3.98,3.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.81,11.03h-3.3V3.85c0-2.12-1.73-3.85-3.85-3.85h-9.09c-2.12,0-3.85,1.73-3.85,3.85v.99h-4.74c-2.12,0-3.85,1.73-3.85,3.85v7.18h-3.3c-2.12,0-3.85,1.73-3.85,3.85v20.89c0,2.12,1.73,3.85,3.85,3.85h23.38c2.12,0,3.85-1.73,3.85-3.85v-.99h4.74c2.12,0,3.85-1.73,3.85-3.85V14.87c0-2.12-1.73-3.85-3.85-3.85ZM18.46,3.85c0-.62.5-1.12,1.12-1.12h9.09c.62,0,1.12.5,1.12,1.12v7.18h-5.85v-2.34c0-2.12-1.73-3.85-3.85-3.85h-1.62v-.99ZM9.88,8.69c0-.62.5-1.12,1.12-1.12h9.09c.62,0,1.12.5,1.12,1.12v7.18h-11.32v-7.18ZM28.34,40.6c0,.62-.5,1.12-1.12,1.12H3.85c-.62,0-1.12-.5-1.12-1.12v-20.89c0-.62.5-1.12,1.12-1.12h23.38c.62,0,1.12.5,1.12,1.12v20.89ZM36.92,35.76c0,.62-.5,1.12-1.12,1.12h-4.74v-17.16c0-2.12-1.73-3.85-3.85-3.85h-3.3v-2.11h11.88c.62,0,1.12.5,1.12,1.12v20.89Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoFactor);
export default __webpack_public_path__ + "static/media/two-factor.aec6934cf07fe91bd2c675b85637bcf0.svg";
export { ForwardRef as ReactComponent };